import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/about-us/AboutUsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/about-us/AnimatedCounter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/about-us/BranchSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/section/GallerySection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@heroui/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
